import HeroSection from "../components/about/hero.jsx";
import AgentCard from "../components/home/AgentCard.jsx";
import GetStarted from "../components/home/GetStarted.jsx";
import Footer from "../components/Footer.jsx";
import VisionSection from "../components/about/VisionSection.jsx";
import AIPlatformSection from "../components/about/BuildingSection.jsx";
import WhyItMatters from "../components/about/WhySection.jsx";
const AboutPage = () => {
  return (
    <div>
      <HeroSection />
      <VisionSection/>
      <AIPlatformSection/>
      <WhyItMatters/>
      <GetStarted />
      <AgentCard />
      <Footer />
    </div>
  );
};

export default AboutPage;
